module.exports = __webpack_public_path__ + "static/img/14000126.95759cce.png";